import { api } from "@/constants"
import { getAuthHeader, serializeQueryParams } from "@/util"
import baseURL from "@/service/api"

const partner = {
  partnerList: (params) => {
    const url = api.partner.list + serializeQueryParams(params)
    return baseURL.get(url, { headers: getAuthHeader() })
  },
  partnerTypes: () => {
    const url = api.partner.type
    return baseURL.get(url, { headers: getAuthHeader() })
  },
  deliveryServices: () => {
    const url = api.partner.deliveryServices
    return baseURL.get(url, { headers: getAuthHeader() })
  },
  packages: (id) => {
    const url = api.deliveryService.packages(id)
    return baseURL.get(url, { headers: getAuthHeader() })
  },
  updateStatus: (id, payloads) => {
    const url = api.partner.updateStatus(id)
    return baseURL.put(url, payloads, { headers: getAuthHeader() })
  },
  partnerDetail: (id) => {
    const url = api.partner.detail(id)
    return baseURL.get(url, { headers: getAuthHeader() })
  },
  packageList: (id, params) => {
    const url = api.partner.package(id) + serializeQueryParams(params)
    return baseURL.get(url, { headers: getAuthHeader() })
  },
  packageDetail: (partnerId, packageId) => {
    const url = api.partner.packageDetail(partnerId, packageId)
    return baseURL.get(url, { headers: getAuthHeader() })
  },
  removePackage: (partnerId, packageId) => {
    const url = api.partner.packageDetail(partnerId, packageId)
    return baseURL.delete(url, { headers: getAuthHeader() })
  },
  updatePackage: (partnerId, packageId, payloads) => {
    const url = api.partner.packageDetail(partnerId, packageId)
    return baseURL.put(url, payloads, { headers: getAuthHeader() })
  },
  costMapping: (partnerId, params) => {
    const url =
      api.partner.costMapping(partnerId) + serializeQueryParams(params)
    return baseURL.get(url, { headers: getAuthHeader() })
  },
  costMappingDetail: (partnerId, costMappingId) => {
    const url = api.partner.costMappingDetail(partnerId, costMappingId)
    return baseURL.get(url, { headers: getAuthHeader() })
  },
  duplicateCostMapping: (partnerId, costMappingId, payloads) => {
    const url = api.partner.duplicateCostMapping(partnerId, costMappingId)
    return baseURL.post(url, payloads, { headers: getAuthHeader() })
  },
  updateCostMapping: (partnerId, costMappingId, payloads) => {
    const url = api.partner.costMappingDetail(partnerId, costMappingId)
    return baseURL.put(url, payloads, { headers: getAuthHeader() })
  },
  createCostMapping: (partnerId, payloads) => {
    const url = api.partner.costMapping(partnerId)
    return baseURL.post(url, payloads, { headers: getAuthHeader() })
  },
  removeCostMapping: (partnerId, costMappingId) => {
    const url = api.partner.costMappingDetail(partnerId, costMappingId)
    return baseURL.delete(url, { headers: getAuthHeader() })
  },
  createPackage: (id, payloads) => {
    const url = api.partner.package(id)
    return baseURL.post(url, payloads, { headers: getAuthHeader() })
  },
  createPartner: (payloads) => {
    const url = api.partner.list
    return baseURL.post(url, payloads, { headers: getAuthHeader() })
  },
  partnerVehicle: (partnerId, params) => {
    const url = api.partner.vehicle(partnerId) + serializeQueryParams(params)
    return baseURL.get(url, { headers: getAuthHeader() })
  },
  baseCost: (partnerId, costMappingId, params) => {
    const url =
      api.partner.baseCost(partnerId, costMappingId) +
      serializeQueryParams(params)
    return baseURL.get(url, { headers: getAuthHeader() })
  },
  createBaseCost: (partnerId, costMappingId, payloads) => {
    const url = api.partner.baseCost(partnerId, costMappingId)
    return baseURL.post(url, payloads, { headers: getAuthHeader() })
  },
  baseCostDetail: (partnerId, costMappingId, baseCostId) => {
    const url = api.partner.baseCostDetail(partnerId, costMappingId, baseCostId)
    return baseURL.get(url, { headers: getAuthHeader() })
  },
  updateBaseCost: (partnerId, costMappingId, baseCostId, payloads) => {
    const url = api.partner.baseCostDetail(partnerId, costMappingId, baseCostId)
    return baseURL.put(url, payloads, { headers: getAuthHeader() })
  },
  removeBaseCost: (partnerId, costMappingId, baseCostId) => {
    const url = api.partner.baseCostDetail(partnerId, costMappingId, baseCostId)
    return baseURL.delete(url, { headers: getAuthHeader() })
  },
  partnerLogos: (params) => {
    const url = api.partner.logos + serializeQueryParams(params)
    return baseURL.get(url, { headers: getAuthHeader() })
  },
  addPartnerLogo: (payloads) => {
    const url = api.partner.logos
    return baseURL.post(url, payloads, { headers: getAuthHeader() })
  },
  changePartnerLogo: (id, payloads) => {
    const url = api.partner.logos
    return baseURL.put(`${url}/${id}`, payloads, { headers: getAuthHeader() })
  },
  deletePartnerLogo: (id) => {
    const url = api.partner.logos
    return baseURL.delete(`${url}/${id}`, { headers: getAuthHeader() })
  },
  selfRegistration: (params) => {
    const url = api.partner.selfRegistration + serializeQueryParams(params)
    return baseURL.get(url, { headers: getAuthHeader() })
  }
}
export default partner
